import React from "react";
import styles from "./SDKTiles.module.css";
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import CodeIcon from '@mui/icons-material/Code';

function SDKTiles() {
    const features = [
        {
            title: "Android (Kotlin)",
            description: "Native Android SDK with Kotlin support for seamless integration",
            icon: <AndroidIcon className={styles["feature-icon"]} />,
            link: "https://github.com/Presage-Security/SmartSpectra/tree/main/android",
            linkText: "View on GitHub"
        },
        {
            title: "Swift (iOS)",
            description: "Native iOS SDK built with Swift for optimal performance",
            icon: <AppleIcon className={styles["feature-icon"]} />,
            link: "https://github.com/Presage-Security/SmartSpectra/tree/main/swift",
            linkText: "View on GitHub"
        },
        {
            title: "C++",
            description: "Cross-platform C++ SDK for maximum flexibility and control",
            icon: <CodeIcon className={styles["feature-icon"]} />,
            link: "https://github.com/Presage-Security/SmartSpectra/tree/main/cpp",
            linkText: "View on GitHub"
        }
    ];

    return (
        <div className={styles["features-container"]}>
            <div className={styles["features-content"]}>
                <div className={styles["features-heading"]}>
                    <h2>Revolutionary Contactless Sensing</h2>
                    <p className={styles["features-desc"]}>
                        Transform any camera into a powerful biometric sensor
                    </p>
                </div>

                <div className={styles["features-grid"]}>
                    {features.map((feature, index) => (
                        <div 
                            key={index} 
                            className={`${styles["feature-card"]} ${feature.link ? styles["feature-card-clickable"] : ''}`}
                            onClick={feature.link ? () => window.open(feature.link, '_blank') : undefined}
                            style={feature.link ? { cursor: 'pointer' } : {}}
                        >
                            <div className={styles["feature-icon-container"]} aria-hidden="true">
                                {feature.icon}
                            </div>
                            <h3 className={styles["feature-title"]}>{feature.title}</h3>
                            <p className={styles["feature-description"]}>{feature.description}</p>
                            {feature.link && (
                                <p className={styles["feature-link-text"]}>{feature.linkText || 'Learn More'} →</p>
                            )}
                        </div>
                    ))}
                </div>

                <div className={styles["features-actions"]}>
                    <button 
                        className={styles["docs-btn"]}
                        onClick={() => window.open("https://docs.physiology.presagetech.com", '_blank')}
                    >
                        View Documentation
                    </button>
                    <button 
                        className={styles["quickstart-btn"]}
                        onClick={() => window.location.href = '/quickstart'}
                    >
                        View Quick Start Guide
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SDKTiles;